import styled from 'styled-components'
import { theme } from '../config'

export const Spinner = styled.div`
  align-self: center;
  width: 44px;
  height: 44px;
  border: 4px ${theme.colors.gray[400]} solid;
  border-top: 4px ${theme.colors.secondary[500]} solid;
  border-radius: 50%;
  -webkit-animation: spCircRot 0.6s infinite linear;
  animation: spCircRot 0.6s infinite linear;

  @-webkit-keyframes spCircRot {
    from {
      -webkit-transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(359deg);
    }
  }
  @keyframes spCircRot {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`
